import { useMatch, Link } from "react-router-dom";

import useQueryParams from "../../../auxiliar/customHooks/useQueryParams";
import { getDynamicLink } from "../../../auxiliar/auxFunctions";

const SmallFooter = ({ variation = "agenda" }) => {
    const reservation = useMatch("/reservation/*");
    const params = useQueryParams();

    const isAgendaVariation = variation === "agenda";

    return (
        <footer
            className={
                isAgendaVariation
                    ? "bg-base-100 border-t border-primary/20 backdrop-blur-sm"
                    : "md:hidden bg-gradient-to-r from-primary/5 via-primary/5 to-secondary/5 shadow-lg border-t border-primary/10"
            }
        >
            <div className={`${isAgendaVariation ? "px-4 py-6" : "px-6 py-8"} max-w-4xl mx-auto`}>
                {/* Brand Section for Mobile */}
                {!isAgendaVariation && (
                    <div className="text-center mb-6">
                        <div className="flex items-center justify-center space-x-2 mb-2">
                            <div className="bg-primary/10 p-1.5 rounded-xl shadow-lg">
                                <img
                                    src={require("../../../media/icon/icon_64.png")}
                                    alt="MiFisio Logo"
                                    className="w-4 h-4"
                                />
                            </div>
                            <h3 className="text-lg font-bold text-primary">MiFisio</h3>
                        </div>
                        <p className="text-xs text-base-content/60 max-w-xs mx-auto">
                            Plataforma líder en gestión de citas, historiales y cobros para
                            fisioterapeutas
                        </p>
                    </div>
                )}

                {/* Navigation Links */}
                <nav className={`${isAgendaVariation ? "mb-4" : "mb-6"}`}>
                    <div
                        className={`flex ${isAgendaVariation ? "justify-center space-x-6" : "justify-center space-x-8"}`}
                    >
                        <Link
                            className="text-sm text-base-content/70 hover:text-primary transition-all duration-200 font-medium relative group"
                            to={getDynamicLink(
                                reservation ? "/reservation" : "",
                                "about-us",
                                params,
                            )}
                        >
                            {isAgendaVariation ? "Nosotros" : "Sobre nosotros"}
                            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-primary transition-all duration-200 group-hover:w-full" />
                        </Link>
                        <a
                            className="text-sm text-base-content/70 hover:text-primary transition-all duration-200 font-medium relative group"
                            href="mailto:soporte@mifisioagenda.com"
                        >
                            Contacto
                            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-primary transition-all duration-200 group-hover:w-full" />
                        </a>
                        <Link
                            className="text-sm text-base-content/70 hover:text-primary transition-all duration-200 font-medium relative group"
                            to={getDynamicLink(
                                reservation ? "/reservation" : "",
                                "privacy-policy",
                                params,
                            )}
                        >
                            Privacidad
                            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-primary transition-all duration-200 group-hover:w-full" />
                        </Link>
                    </div>
                </nav>

                {/* Copyright */}
                <div className="text-center">
                    <p
                        className={`${isAgendaVariation ? "text-xs" : "text-sm"} text-base-content/60 font-medium`}
                    >
                        © {new Date().getFullYear()} MFISIO SCHEDULA SL
                    </p>
                    {!isAgendaVariation && (
                        <div className="flex items-center justify-center space-x-3 mt-2 text-xs">
                            <span className="text-secondary font-medium">
                                Hecho por y para fisios
                            </span>
                        </div>
                    )}
                </div>
            </div>
        </footer>
    );
};

export default SmallFooter;
